// @flow

import { type Grecaptcha } from './types';
import { LoadGrecaptcha } from './load-grecaptcha';
import { loadScript } from '@tectonics/commons/load-script';

export function loadGrecaptchaFromScriptWithMaxTries(maxTries: number): LoadGrecaptcha {
  return new LoadGrecaptcha(loadGrecaptchaFromScriptFn, maxTries);
}

async function loadGrecaptchaFromScriptFn(): Promise<Grecaptcha> {
  await loadScript('https://www.google.com/recaptcha/api.js?render=explicit');
  if (!window.grecaptcha) throw new Error('loadGrecaptcha - Grecaptcha not loaded');
  return window.grecaptcha;
}
